import { __assign } from "tslib";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var Joystick = React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return React.createElement(StyledIconBase, __assign({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), React.createElement("path", {
    fill: "none",
    d: "M19.98 8.72C19.877 7.225 18.567 6 17 6H7a2.977 2.977 0 00-2.991 2.867.98.98 0 01-.018.155L4 16.5c0 .397.159.784.437 1.062.279.279.666.438 1.063.438.5 0 1.038-.638 1.661-1.377.336-.397.717-.849 1.149-1.261.577-.55 1.821-1.099 2.459-1.249.418-.098.951-.113 1.231-.113s.813.015 1.229.112c.64.151 1.884.7 2.461 1.249.433.413.813.864 1.149 1.262C17.462 17.362 18 18 18.5 18a1.51 1.51 0 001.062-.437c.279-.279.438-.666.438-1.063V9c-.013-.063-.01-.096-.01-.16a.427.427 0 01-.01-.12zM8 12a2 2 0 11-.001-3.999A2 2 0 018 12zm8-5a1 1 0 110 2 1 1 0 110-2zm-2 4a1 1 0 110-2 1 1 0 110 2zm2 2a1 1 0 110-2 1 1 0 110 2zm2-2a1 1 0 110-2 1 1 0 110 2z",
    key: "k0"
  }), React.createElement("path", {
    d: "M21.979 8.652A5.005 5.005 0 0017 4H7a4.97 4.97 0 00-4.987 4.737c-.01.079-.013.161-.013.253v7.51c0 .925.373 1.828 1.022 2.476A3.524 3.524 0 005.5 20c1.429 0 2.324-1.061 3.189-2.087.318-.377.646-.767 1-1.103.237-.226 1.102-.647 1.539-.751.252-.059 1.293-.058 1.541-.001.439.104 1.304.526 1.541.751.354.337.682.727 1 1.104C16.176 18.939 17.071 20 18.5 20c.925 0 1.828-.373 2.476-1.022A3.524 3.524 0 0022 16.5V9c0-.095-.004-.18-.014-.26l-.007-.088zM20 16.5c0 .397-.159.784-.438 1.063A1.51 1.51 0 0118.5 18c-.5 0-1.038-.638-1.661-1.377-.336-.397-.717-.849-1.149-1.262-.577-.549-1.821-1.098-2.461-1.249C12.813 14.015 12.28 14 12 14s-.813.015-1.23.113c-.638.15-1.882.699-2.459 1.249-.433.412-.813.863-1.149 1.261C6.538 17.362 6 18 5.5 18c-.397 0-.784-.159-1.063-.438A1.51 1.51 0 014 16.5l-.009-7.478c.01-.051.016-.103.018-.155A2.977 2.977 0 017 6h10c1.567 0 2.877 1.225 2.98 2.72 0 .06.005.12.01.12 0 .064-.003.097.01.16v7.5z",
    key: "k1"
  }), React.createElement("circle", {
    cx: 16,
    cy: 12,
    r: 1,
    key: "k2"
  }), React.createElement("circle", {
    cx: 18,
    cy: 10,
    r: 1,
    key: "k3"
  }), React.createElement("circle", {
    cx: 16,
    cy: 8,
    r: 1,
    key: "k4"
  }), React.createElement("circle", {
    cx: 14,
    cy: 10,
    r: 1,
    key: "k5"
  }), React.createElement("circle", {
    cx: 8,
    cy: 10,
    r: 2,
    key: "k6"
  }));
});
Joystick.displayName = 'Joystick';
export var JoystickDimensions = {
  height: 24,
  width: 24
};